/**
 * Featured product shared runtime.
 * Keeps the sticky purchase bar, variant/selling-plan values, prices, and the
 * native add-to-cart form synchronized within the current Shopify section.
 */
(function () {
    'use strict';

    const hostScript = document.currentScript;
    const SECTION_ID = hostScript ? hostScript.dataset.sectionId : '';
    const PRODUCT_FORM_ID = 'product-form-' + SECTION_ID;

    function init() {
      const sectionEl = document.getElementById('shopify-section-' + SECTION_ID);
      if (!sectionEl || sectionEl.dataset.wbFeaturedRuntimeInitialized === '1') return;
      sectionEl.dataset.wbFeaturedRuntimeInitialized = '1';

      const navEls = document.querySelectorAll('.product-nav[data-featured-product-nav][data-section-id="' + SECTION_ID + '"]');
      if (!navEls.length) return;

      // 如果页面上已经存在来自 main-product 的 .product-nav（且不是 featured-product 渲染的），
      // 移除当前 featured-product 的悬浮栏，避免重复
      let hasMainProductNav = false;
      document.querySelectorAll('.product-nav').forEach(function (el) {
        if (!el.hasAttribute('data-featured-product-nav')) {
          hasMainProductNav = true;
        }
      });
      if (hasMainProductNav) {
        navEls.forEach(function (el) {
          el.parentNode && el.parentNode.removeChild(el);
        });
        return;
      }

      const productNav = navEls[0];
      const navPtitle = productNav.querySelector('.nav_ptitle');
      // [2026-05-28] 与 main-product 对齐：新旧两套元素并存
      // PC 旧结构
      const navPrice = productNav.querySelector('.navp_price');
      const navComparePrice = productNav.querySelector('.navp_compare_price');
      const navPeriodTotal = productNav.querySelector('.navp_period_total');
      const navSaveBadge = productNav.querySelector('.navp_save_badge');
      // Mobile 新结构
      const navSkuName = productNav.querySelector('.nav__sku-name');
      const navSkuTotal = productNav.querySelector('.nav__sku-total');
      const navCart = productNav.querySelector('.nav_cart');
      if (!navCart) return;
      if (!navPrice && !navSkuName) return; // 两套至少一套就绪

      // 当前页面可能同时存在其它商品组件；订阅状态只能读取本 featured-product section。
      function queryInSection(selector) {
        return sectionEl.querySelector(selector);
      }

      // ==================== 同步 variant / selling_plan 到所有加购表单 ====================
      function getAddToCartForms() {
        const forms = sectionEl.querySelectorAll('form[action*="/cart/add"]');
        const result = [];
        forms.forEach(function (form) {
          if (form.querySelector('button[name="add"], button[type="submit"][class*="product-form__submit"]')) {
            result.push(form);
          }
        });
        return result;
      }

      function applyVariantToForm(form, variantId, sellingPlanId) {
        if (!form) return;
        const variantInput = form.querySelector('input[name="id"]');
        const variantSelect = form.querySelector('select[name="id"]');

        if (variantInput) {
          variantInput.value = variantId;
        } else if (variantSelect) {
          variantSelect.value = variantId;
          const changeEvent = new Event('change', { bubbles: true });
          variantSelect.dispatchEvent(changeEvent);
        }

        let sellingPlanInput = form.querySelector('input[name="selling_plan"]');
        if (sellingPlanId) {
          if (!sellingPlanInput) {
            sellingPlanInput = document.createElement('input');
            sellingPlanInput.type = 'hidden';
            sellingPlanInput.name = 'selling_plan';
            form.appendChild(sellingPlanInput);
          }
          sellingPlanInput.value = sellingPlanId;
        } else if (sellingPlanInput) {
          sellingPlanInput.remove();
        }
      }

      function syncSelectedOptionToForm() {
        const selectedPlanLabel = queryInSection('.plan-label.selected:not(.one-time-purchase-card)');
        const selectedSubscriptionRadio = queryInSection('.plan-radio:checked:not(.one-time-radio)');

        let variantId = '';
        let sellingPlanId = '';
        let hasValidSelection = false;

        if (selectedPlanLabel || selectedSubscriptionRadio) {
          const radio = selectedSubscriptionRadio || selectedPlanLabel.querySelector('.plan-radio');
          if (radio) {
            variantId = radio.getAttribute('data-variant-id');
            sellingPlanId = radio.getAttribute('data-selling-plan-id') || radio.value;
            hasValidSelection = true;
          }
        } else {
          const activeOneTimeCard = queryInSection('.one-time-purchase-card.active-variant');
          const selectedOneTimeRadio = queryInSection('.one-time-radio:checked');
          if (activeOneTimeCard || selectedOneTimeRadio) {
            const variantSelector = queryInSection('#one-time-variant-selector');
            if (variantSelector) {
              const selectedOption = variantSelector.options[variantSelector.selectedIndex];
              if (selectedOption) {
                variantId = selectedOption.getAttribute('data-variant-id') || selectedOption.value;
                sellingPlanId = '';
                hasValidSelection = true;
              }
            }
          }
        }
        if (!hasValidSelection || !variantId) return;

        const wonderbioticsVariantInput = queryInSection('#wonderbiotics-variant-id');
        const wonderbioticsSellingPlanInput = queryInSection('#wonderbiotics-selling-plan');
        if (wonderbioticsVariantInput) wonderbioticsVariantInput.value = variantId;
        if (wonderbioticsSellingPlanInput) wonderbioticsSellingPlanInput.value = sellingPlanId || '';

        getAddToCartForms().forEach(function (form) {
          applyVariantToForm(form, variantId, sellingPlanId);
        });
      }

      // ==================== 更新 nav 标题 / 价格（订阅模式） ====================
      // [2026-05-28] 与 main-product 对齐：同时写 PC 旧结构 + Mobile 新结构
      function updateNavFromSubscription() {
        let selectedPlanLabel = queryInSection('.plan-label.selected:not(.one-time-purchase-card)');
        if (!selectedPlanLabel) {
          const checkedRadio = queryInSection('.plan-radio:checked:not(.one-time-radio)');
          if (checkedRadio) {
            selectedPlanLabel = checkedRadio.closest('.plan-label');
          }
        }
        if (!selectedPlanLabel) return;

        syncSelectedOptionToForm();

        const planContent = selectedPlanLabel.querySelector('.plan-content');

        // ====== 公共：变体名 → 顶部锚点 + Mobile 第一行 ======
        const variantNameElement = (planContent && planContent.querySelector('.header_save-title .variant-name'))
          || selectedPlanLabel.querySelector('.variant-name');
        const titleText = variantNameElement ? variantNameElement.textContent.trim() : '';
        if (titleText) {
          if (navPtitle) navPtitle.textContent = titleText;
          if (navSkuName) navSkuName.textContent = titleText;
        }

        // ====== PC 旧结构：$X/mo + $Y/day + SAVE 徽章 + $X every Y days ======
        if (navPrice) {
          const planPricing = selectedPlanLabel.querySelector('.plan-pricing');
          if (planPricing) {
            const priceRow = planPricing.querySelector('.price-row');
            if (priceRow) {
              const priceDiv = priceRow.querySelector('div');
              const scope = priceDiv || priceRow;

              // 现价 .price-current（如 $44.32/mo）
              const priceCurrentElement = scope.querySelector('.price-current');
              if (priceCurrentElement) {
                navPrice.innerHTML = priceCurrentElement.textContent.trim();
              }

              // 单日均价 .price-original（如 $1.47/day）— PC 端已 display:none !important，仅写文本兼容
              if (navComparePrice) {
                const priceOriginalElement = scope.querySelector('.price-original');
                if (priceOriginalElement) {
                  const sTag = priceOriginalElement.querySelector('s');
                  navComparePrice.innerHTML = sTag ? sTag.textContent.trim() : priceOriginalElement.textContent.trim();
                  navComparePrice.style.display = 'inline';
                } else {
                  navComparePrice.style.display = 'none';
                }
              }

              // SAVE 徽章
              if (navSaveBadge) {
                const saveTitle = planContent ? planContent.querySelector('.header_save-title') : null;
                const saveBadgeElement = saveTitle ? saveTitle.querySelector('.price-save') : null;
                if (saveBadgeElement) {
                  navSaveBadge.innerHTML = saveBadgeElement.textContent.trim();
                  navSaveBadge.style.display = '';
                } else {
                  navSaveBadge.style.display = 'none';
                }
              }

              // [2026-05-28] $1.47/day 下方追加变体总价 .plan-period-total（"$132.96 every 90 days"）
              if (navPeriodTotal) {
                const periodTotalEl = selectedPlanLabel.querySelector('.plan-period-total');
                if (periodTotalEl) {
                  navPeriodTotal.textContent = periodTotalEl.textContent.trim();
                  navPeriodTotal.style.display = '';
                } else {
                  const pcFallbackPc = selectedPlanLabel.querySelector('.price-current[data-total-price-formatted]');
                  if (pcFallbackPc) {
                    navPeriodTotal.textContent = pcFallbackPc.getAttribute('data-total-price-formatted') || '';
                    navPeriodTotal.style.display = '';
                  } else {
                    navPeriodTotal.textContent = '';
                    navPeriodTotal.style.display = 'none';
                  }
                }
              }
            }
          }
        }

        // ====== Mobile 新结构：第二行总价文案 ======
        if (navSkuTotal) {
          const periodTotalElM = selectedPlanLabel.querySelector('.plan-period-total');
          if (periodTotalElM) {
            navSkuTotal.textContent = periodTotalElM.textContent.trim();
            navSkuTotal.style.display = '';
          } else {
            const pcFallbackM = selectedPlanLabel.querySelector('.price-current[data-total-price-formatted]');
            if (pcFallbackM) {
              navSkuTotal.textContent = pcFallbackM.getAttribute('data-total-price-formatted') || '';
              navSkuTotal.style.display = '';
            } else {
              navSkuTotal.textContent = '';
              navSkuTotal.style.display = 'none';
            }
          }
        }
      }

      // ==================== 更新 nav 标题 / 价格（一次性购买模式） ====================
      // [2026-05-28] 与 main-product 对齐：同时写 PC + Mobile，period-total 隐藏（无周期）
      function updateNavFromOneTimePurchase() {
        const oneTimeCard = queryInSection('.one-time-purchase-card');
        if (!oneTimeCard) return;

        const variantSelector = queryInSection('#one-time-variant-selector');
        if (!variantSelector) return;

        const selectedOption = variantSelector.options[variantSelector.selectedIndex];
        if (!selectedOption) return;

        let variantTitle = selectedOption.getAttribute('data-variant-title');
        let variantPrice = selectedOption.getAttribute('data-variant-price');

        if (!variantTitle || !variantPrice) {
          const optionText = selectedOption.textContent.trim();
          const parts = optionText.split(' - ');
          if (parts.length >= 2) {
            variantTitle = variantTitle || parts[0].trim();
            variantPrice = variantPrice || parts[1].trim();
          } else {
            variantTitle = variantTitle || optionText;
          }
        }

        // ====== 公共：SKU 名 → 顶部锚点 + Mobile 第一行 ======
        const titleText = variantTitle || 'One-time purchase';
        if (navPtitle) navPtitle.textContent = titleText;
        if (navSkuName) navSkuName.textContent = titleText;

        // 兜底取价
        if (!variantPrice) {
          const priceDisplay = queryInSection('#one-time-price-display');
          if (priceDisplay && priceDisplay.textContent.trim()) {
            variantPrice = priceDisplay.textContent.trim();
          }
        }

        // ====== PC 旧结构：价格 + 隐藏 compare/save/period-total ======
        if (navPrice && variantPrice) navPrice.innerHTML = variantPrice;
        if (navComparePrice) navComparePrice.style.display = 'none';
        if (navSaveBadge) navSaveBadge.style.display = 'none';
        if (navPeriodTotal) {
          navPeriodTotal.textContent = '';
          navPeriodTotal.style.display = 'none';
        }

        // ====== Mobile 新结构：第二行纯价格 ======
        if (navSkuTotal) {
          if (variantPrice) {
            navSkuTotal.textContent = variantPrice;
            navSkuTotal.style.display = '';
          } else {
            navSkuTotal.textContent = '';
            navSkuTotal.style.display = 'none';
          }
        }

        syncSelectedOptionToForm();
      }

      function refreshNav() {
        const selectedPlanLabel = queryInSection('.plan-label.selected:not(.one-time-purchase-card)');
        const selectedSubscriptionRadio = queryInSection('.plan-radio:checked:not(.one-time-radio)');
        const activeOneTimeCard = queryInSection('.one-time-purchase-card.active-variant');
        const selectedOneTimeRadio = queryInSection('.one-time-radio:checked');

        if (selectedPlanLabel || selectedSubscriptionRadio) {
          updateNavFromSubscription();
        } else if (activeOneTimeCard || selectedOneTimeRadio) {
          updateNavFromOneTimePurchase();
        }
      }

      // Appstle 一次点击会连续改写 radio/class；合并短时间内的刷新，最终状态不变。
      let refreshTimer = null;
      function scheduleRefresh(callback, delay) {
        if (refreshTimer) clearTimeout(refreshTimer);
        refreshTimer = setTimeout(function () {
          refreshTimer = null;
          callback();
        }, delay);
      }

      // ==================== 监听订阅 / 一次性购买的选择变化 ====================
      function setupSubscriptionListeners() {
        const planLabels = sectionEl.querySelectorAll('.plan-label:not(.one-time-purchase-card)');
        planLabels.forEach(function (label) {
          label.addEventListener('click', function () {
            scheduleRefresh(updateNavFromSubscription, 150);
          });
        });

        const subscriptionRadios = sectionEl.querySelectorAll('.plan-radio:not(.one-time-radio)');
        subscriptionRadios.forEach(function (radio) {
          radio.addEventListener('change', function () { scheduleRefresh(updateNavFromSubscription, 100); });
          radio.addEventListener('click', function () { scheduleRefresh(updateNavFromSubscription, 100); });
        });

        const oneTimeCard = queryInSection('.one-time-purchase-card');
        if (oneTimeCard) {
          oneTimeCard.addEventListener('click', function () {
            scheduleRefresh(updateNavFromOneTimePurchase, 150);
          });
        }

        const oneTimeRadio = queryInSection('.one-time-radio');
        if (oneTimeRadio) {
          oneTimeRadio.addEventListener('change', function () { scheduleRefresh(updateNavFromOneTimePurchase, 100); });
        }

        const variantSelector = queryInSection('#one-time-variant-selector');
        if (variantSelector) {
          variantSelector.addEventListener('change', function () {
            const oneTimeRadioChecked = queryInSection('.one-time-radio:checked');
            const oneTimeCardActive = queryInSection('.one-time-purchase-card.active-variant');
            if (oneTimeRadioChecked || oneTimeCardActive) {
              scheduleRefresh(updateNavFromOneTimePurchase, 100);
            } else {
              const hasSubscriptionSelected = queryInSection('.plan-label.selected:not(.one-time-purchase-card)') ||
                queryInSection('.plan-radio:checked:not(.one-time-radio)');
              if (!hasSubscriptionSelected) scheduleRefresh(updateNavFromOneTimePurchase, 100);
            }
          });
          variantSelector.addEventListener('input', function () {
            const oneTimeRadioChecked = queryInSection('.one-time-radio:checked');
            const oneTimeCardActive = queryInSection('.one-time-purchase-card.active-variant');
            if (oneTimeRadioChecked || oneTimeCardActive) {
              scheduleRefresh(updateNavFromOneTimePurchase, 100);
            }
          });
        }

        sectionEl.addEventListener('change', function (event) {
          if (event.target && event.target.classList && event.target.classList.contains('plan-radio')) {
            if (event.target.classList.contains('one-time-radio')) {
              scheduleRefresh(updateNavFromOneTimePurchase, 100);
            } else {
              scheduleRefresh(updateNavFromSubscription, 100);
            }
          }
        });

        if (typeof MutationObserver !== 'undefined') {
          const observer = new MutationObserver(function (mutations) {
            let shouldUpdate = false;
            mutations.forEach(function (mutation) {
              if (mutation.type === 'attributes' && mutation.attributeName === 'checked') {
                shouldUpdate = true;
              }
              if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                const target = mutation.target;
                if (target.classList) {
                  if (target.classList.contains('plan-label')) {
                    const hadSelected = mutation.oldValue && mutation.oldValue.indexOf('selected') !== -1;
                    const hasSelected = target.classList.contains('selected');
                    if (hadSelected !== hasSelected) shouldUpdate = true;
                  }
                  if (target.classList.contains('one-time-purchase-card')) {
                    const hadActive = mutation.oldValue && mutation.oldValue.indexOf('active-variant') !== -1;
                    const hasActive = target.classList.contains('active-variant');
                    if (hadActive !== hasActive) shouldUpdate = true;
                  }
                }
              }
              if (mutation.type === 'childList') {
                for (let i = 0; i < mutation.addedNodes.length; i++) {
                  const node = mutation.addedNodes[i];
                  if (node.nodeType === 1 && (
                    (node.matches && (node.matches('.plan-radio') || node.matches('.subscription-plan-item') || node.matches('.plan-label'))) ||
                    (node.querySelector && node.querySelector('.plan-radio, .subscription-plan-item, .plan-label'))
                  )) {
                    shouldUpdate = true;
                    break;
                  }
                }
              }
            });
            if (shouldUpdate) scheduleRefresh(refreshNav, 200);
          });

          const subscriptionContainer = queryInSection('.wonderbiotics-subscriptions-wrapper');
          if (subscriptionContainer) {
            observer.observe(subscriptionContainer, {
              childList: true,
              subtree: true,
              attributes: true,
              attributeFilter: ['checked', 'class'],
              attributeOldValue: true
            });
          }
          const forms = sectionEl.querySelectorAll('form, .product-form');
          forms.forEach(function (form) {
            observer.observe(form, {
              childList: true,
              subtree: true,
              attributes: true,
              attributeFilter: ['checked', 'class'],
              attributeOldValue: true
            });
          });
        }
      }

      // ==================== 初始化：等待订阅组件加载完成 ====================
      function initNavUpdate() {
        refreshNav();
        let retryCount = 0;
        const maxRetries = 6;

        // 仅覆盖 Appstle 首次异步插入选项的窗口，避免持续轮询占用主线程。
        function syncWhenSelectionReady() {
          retryCount++;
          const hasSubscription = queryInSection('.plan-label.selected:not(.one-time-purchase-card)') ||
            queryInSection('.plan-radio:checked:not(.one-time-radio)');
          const hasOneTime = queryInSection('.one-time-purchase-card.active-variant') ||
            queryInSection('.one-time-radio:checked');
          if (hasSubscription) {
            updateNavFromSubscription();
          } else if (hasOneTime) {
            updateNavFromOneTimePurchase();
          } else if (retryCount < maxRetries) {
            setTimeout(syncWhenSelectionReady, 250);
          }
        }

        syncWhenSelectionReady();
      }

      initNavUpdate();
      setupSubscriptionListeners();

      document.addEventListener('subscriptionSelected', function () {
        scheduleRefresh(refreshNav, 100);
      });

      // ==================== nav 加购按钮 -> 触发产品页原生加购按钮 ====================
      function findShopifyAddToCartButton() {
        const productForm = document.getElementById(PRODUCT_FORM_ID) ||
          sectionEl.querySelector('form[action*="/cart/add"]');
        if (!productForm) return null;

        const buttons = productForm.querySelectorAll('button[name="add"], button[type="submit"], [data-add-to-cart], .product-form__submit, .product-form__cart-submit, [data-buy-buttons-atc]');
        for (let i = 0; i < buttons.length; i++) {
          const button = buttons[i];
          if (!productNav.contains(button)) return button;
        }

        const productInfo = sectionEl.querySelector('product-info');
        if (productInfo) {
          const infoButtons = productInfo.querySelectorAll('button[name="add"], button[type="submit"], [data-add-to-cart], .product-form__submit');
          if (infoButtons.length > 0) return infoButtons[0];
        }
        return null;
      }

      let navCartSetupAttempts = 0;
      function setupNavCartButton() {
        const shopifyButton = findShopifyAddToCartButton();
        if (!shopifyButton) {
          // 原生加购按钮未就绪时有限次重试，避免异常页面留下永久定时器。
          navCartSetupAttempts++;
          if (navCartSetupAttempts < 6) setTimeout(setupNavCartButton, 1000);
          return;
        }

        const navAddToCartButtons = navCart.querySelectorAll('button[name="add"], button[type="submit"], [data-add-to-cart], .product-form__submit, .shopify-payment-button__button');
        navAddToCartButtons.forEach(function (button) {
          if (button.hasAttribute('data-nav-synced')) return;
          button.setAttribute('data-nav-synced', 'true');
          button.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            syncSelectedOptionToForm();
            setTimeout(function () {
              const btn = findShopifyAddToCartButton();
              if (btn && !btn.disabled) btn.click();
            }, 50);
          }, true);
        });

        if (typeof MutationObserver !== 'undefined') {
          const observer = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
              mutation.addedNodes.forEach(function (node) {
                if (node.nodeType === 1) {
                  const buttons = node.querySelectorAll
                    ? node.querySelectorAll('button[name="add"], button[type="submit"], [data-add-to-cart]')
                    : [];
                  buttons.forEach(function (button) {
                    if (navCart.contains(button) && !button.hasAttribute('data-nav-synced')) {
                      button.setAttribute('data-nav-synced', 'true');
                      button.addEventListener('click', function (e) {
                        e.preventDefault();
                        e.stopPropagation();
                        syncSelectedOptionToForm();
                        setTimeout(function () {
                          const btn = findShopifyAddToCartButton();
                          if (btn && !btn.disabled) btn.click();
                        }, 50);
                      }, true);
                    }
                  });
                }
              });
            });
          });
          observer.observe(navCart, { childList: true, subtree: true });
        }
      }

      function setupProductPageCartButton() {
        const forms = getAddToCartForms();
        forms.forEach(function (form) {
          if (form.hasAttribute('data-cart-sync-bound')) return;
          form.setAttribute('data-cart-sync-bound', 'true');
          form.addEventListener('submit', function () { syncSelectedOptionToForm(); }, true);
        });
      }

      setTimeout(function () {
        setupNavCartButton();
        setupProductPageCartButton();
      }, 500);

      // ==================== 滚动显示控制 ====================
      // 使用当前商品主模块底部的固定锚点，与 main-product 保持一致
      function getTriggerEl() {
        return sectionEl.querySelector('[data-sticky-purchase-anchor]');
      }

      function getTriggerOffset() {
        const trigger = getTriggerEl();
        if (!trigger) return Number.POSITIVE_INFINITY;
        const rect = trigger.getBoundingClientRect();
        return rect.top + (window.pageYOffset || document.documentElement.scrollTop || 0);
      }

      // 20260603 - 悬浮加购栏显隐时同步在 <html> 上挂 .featured-nav-visible 标记，
      // 供 frontrow-gpt.liquid 据此隐藏右下角 ClinicianAI 悬浮按钮，避免底部两者重叠。
      function setNavVisible(visible) {
        // 避免相同 class 写入再次触发 section 的 MutationObserver。
        if (productNav.classList.contains('is-visible') !== visible) {
          productNav.classList.toggle('is-visible', visible);
        }
        const html = document.documentElement;
        if (html.classList.contains('featured-nav-visible') !== visible) {
          html.classList.toggle('featured-nav-visible', visible);
        }
      }

      function updateNavVisibility() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
        const anchorTop = getTriggerOffset();
        // 商品主模块底部向上滚过视口顶部后显示悬浮栏
        setNavVisible(scrollTop > anchorTop);
      }

      let ticking = false;
      let visibilityTimer = null;
      // resize 与 DOM 更新常成批发生，只在稳定后测量一次原生加购区的位置。
      function scheduleVisibilityUpdate() {
        if (visibilityTimer) clearTimeout(visibilityTimer);
        visibilityTimer = setTimeout(function () {
          visibilityTimer = null;
          updateNavVisibility();
        }, 100);
      }

      function onScroll() {
        if (!ticking) {
          window.requestAnimationFrame(function () {
            updateNavVisibility();
            ticking = false;
          });
          ticking = true;
        }
      }

      updateNavVisibility();
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', function () {
        scheduleVisibilityUpdate();
      });

      if (typeof MutationObserver !== 'undefined') {
        const visObserver = new MutationObserver(function () {
          scheduleVisibilityUpdate();
        });
        visObserver.observe(sectionEl, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['class', 'style']
        });
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
